import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHotkeys } from 'react-hotkeys-hook';
import { getUnsplash } from '../../modules/editor/service';
import { editContent } from '../../modules/editor/actions';
import Modal from '../Modal/Modal';
import unsplashIcon from '../../assets/images/icon/unsplash.png';
import ImageLibraryInput from './ImageLibraryInput';
import ImageLibraryItem from './ImageLibraryItem';
import useOnScreen from '../../hooks/useOnScreen';
import useAlert from '../../hooks/useAlert';

type Props = {
  target: string;
  close: () => void;
};

function ImageLibrary({ target, close }: Props) {
  const dispatch = useDispatch();
  const Alert = useAlert();

  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [list, setList] = useState([] as any);
  const [selectedImage, setSelectedImage] = useState('');

  const lastOfPageRef = useRef(null);
  const lastOfPageOnScreen = useOnScreen(lastOfPageRef);

  useHotkeys('Esc', () => {
		close();
	});

  useEffect(() => {
    window.parent.postMessage({ msg: 'dialogShow' }, '*');

		return () => {
			window.parent.postMessage({ msg: 'dialogHide' }, '*');
		}
  }, []);
 
  useEffect(() => {     
    if (lastOfPageOnScreen && list.length !== 0 && page <= 5) {
      setPage(page + 1);
    }
  }, [lastOfPageOnScreen]);

  useEffect(() => {
    setPage(1);
    setList([]);
    search();
  }, [keyword]);

  useEffect(() => {
    if (page === 1) {
      search();
    } else {
      loadMore();
    }
  }, [page]);

  const init = async () => {
    const result = await getUnsplash('newsletter', 1);
    setList(result.results);
  }

  const search = async () => {
    if (keyword.length === 0) {
      init();
      return;
    }
    const result = await getUnsplash(keyword, page);
    setList(result.results);
  }

  const loadMore = async () => {    
    const result = await getUnsplash(keyword, page);
    setList([...list, ...result.results]);
  }

  const changeKeyword = (keyword:string) => {		
    setKeyword(keyword);    
  }

  const selectImage = (id:string) => {
    setSelectedImage(id);
  }

  const apply = () => {   
    if (selectedImage === '') {
      Alert.error(Alert?.msg?.DEFAULT_ERROR);
      return;
    }
    const applyImage = list.filter((item:any) => item.id === selectedImage)[0];
    dispatch(editContent({ target: target, data: applyImage?.urls?.regular.replace('q=80&w=1080', 'q=80&w=600') }));
    close();
  }

  const onReset = () => {
    setKeyword('');
    setPage(1);
  }

  return (
    <Modal show={true} close={close}>
      <div className="image-library">
        <header className="image-library-header">
          <h1>
            <img src={unsplashIcon}  />
            Unsplash
          </h1>
          <p>
            영어로 검색어를 입력하세요.
          </p>
        </header>
        <ImageLibraryInput 
          search={changeKeyword} 
          reset={onReset}
        />
        {
          <div className="image-library-list">
            {
              list.length === 0 ? (
                <div className="empty">
                  <p>검색 결과가 없습니다</p>
                </div>
              ) : (
                <ul>
                  {
                    list.map((item:any, index:number) => (
                      <ImageLibraryItem
                        key={index} 
                        item={item}
                        selectedImage={selectedImage}
                        selectImage={selectImage}
                      />
                    ))
                  }
                </ul>
              )
            }
            <div className="last-of-page" ref={lastOfPageRef}></div>
          </div>
        }
        <div className="btns">
          <button className="btn medium tertiary" onClick={close}>취소</button>
          <button className="btn medium secondary" onClick={apply}>추가</button>
        </div>
      </div>
    </Modal>
  );
}

ImageLibrary.defaultProps = {
};

export default ImageLibrary;